import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useLocation } from "react-router-dom"
// import queryString from 'query-string';
import {
  Row,
  Col,
  BreadcrumbItem,
  Label,
  InputGroup,
  CardBody,
  Card,
  Form,
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { getAuthUsers as onGetAuthUser } from "store/actions"
import { GET_AUTH_USERS_DESIGNER, GET_AUTH_USERS_SALES } from "helpers/url_helper"

const FilterComponentForOrders = props => {
  
  const { handleFilterClick, filter } = props

  const location = useLocation()
  const dispatch = useDispatch()

  const { designerUsers, salesUsers } = useSelector(state => ({
    designerUsers: state.Login.designers,
    salesUsers: state.Login.sales,
  }))

  const [formState, setFormState] = useState({
    userName: "",
    orderCode: "",
    orderStatus: { value: "", label: "All Status" },
    salesPerson: { value: "", label: "All Sales" },
    designer: { value: "", label: "All Designers" },
    submitDateTime: [],
  })
  const [path, setPath] = useState("")

  const [designer, setDesigner] = useState([
    { value: "", label: "All Designers" },
  ])
  const [sales, setSales] = useState([
    { value: "", label: "All Sales" },
  ])

  const [orderStatus, setOrderStatus] = useState([
    { value: "", label: "All Status" },
    { value: "Done", label: "Done" },
  ])

  useEffect(() => {
    if (!("docs" in designerUsers)) {
      const filter = { Designation: "designer"}
      const prop = {size:100, page:1} 
      dispatch(onGetAuthUser({prop,filter, url: GET_AUTH_USERS_DESIGNER}))
    } else {
      setDesigner(formatJson(designerUsers, "All Designers"))
    }
  }, [dispatch, designerUsers])

  useEffect(() => {
    if (!("docs" in salesUsers)) {
      const filter = { Designation: "sales"}
      const prop = {size:100, page:1} 
      dispatch(onGetAuthUser({prop, filter, url: GET_AUTH_USERS_SALES }))
    } else {
      setSales(formatJson(salesUsers, "All Sales"))
    }
  }, [dispatch, salesUsers])

  function formatJson(data, lable) {
    const formattedData = data.docs.map(item => ({
      value: item.userName,
      label: item.customerNick,
    }))
    formattedData.unshift({ value: "", label: lable })
    return formattedData
  }

  const page = window.location.pathname

  useEffect(() => {
    const pth = window.location.pathname.split("/")[2]
    setPath(pth)
  }, [])

  const queryParams = new URLSearchParams(location.search)

  const handleInputChange = e => {
    const { id, value } = e.target
    setFormState(prevState => ({
      ...prevState,
      [id]: value.trim(),
    }))
  }

  const handleSelectChange = (selectedOption, type) => {
    setFormState(prevState => ({
      ...prevState,
      [type]: selectedOption,
    }))
  }

  const handleDateChange = selectedDates => {
    // Parse raw date strings into Date objects
    const dates = selectedDates.map(dateStr => new Date(dateStr).toISOString())
    setFormState(prevState => ({
      ...prevState,
      submitDateTime: dates,
    }))
  }

 
  return (
    <Card>
      <CardBody className="row gy-3 gx-4 align-items-center">
        {/* <h5 className="col-sm-3 mt-3">Search Record</h5> */}

        {/* Order No */}
        <div className="col-sm-2">

          <InputGroup>
            <div className="input-group-text">OR</div>
            <input
              type="text"
              className="form-control"
              id="orderCode"
              placeholder="Order No"
              value={formState.orderCode || ""}
              onChange={handleInputChange}
            // onChange={e => setOrderName(e.target.value.trim())}
            />
          </InputGroup>
        </div>

        {path != "view-orders" && path != "view-vectors" && path != "view-quotes" ? (
          <>
            {/* Customer */}
            <div className="col-sm-2">
              <Label className="visually-hidden" htmlFor="email">
                Customer
              </Label>
              <InputGroup>
                {/* <div className="input-group-text">@</div> */}
                <input
                  type="text"
                  className="form-control"
                  id="userName"
                  placeholder="Customer Name"
                  value={formState.userName || ""}
                  onChange={handleInputChange}
                // onChange={e => setOrderName(e.target.value.trim())}
                />
              </InputGroup>
            </div>
            {/* Sales Man */}
            <div className="col-sm-2">
              <label className="visually-hidden" htmlFor="autoSizingSelect">
                Sales Man
              </label>
              <Select
                value={formState.salesPerson}
                transition
                onChange={e => handleSelectChange(e, "salesPerson")}
                options={sales}
                placeholder="Sales Person"
                classNamePrefix="select2-selection"
              />
            </div>
            {/* Designer */}
            <div className="col-sm-2">
              <label className="visually-hidden" htmlFor="autoSizingSelect">
                Designer
              </label>
              <Select
                value={formState.designer}
                transition
                onChange={e => handleSelectChange(e, "designer")}
                options={designer}
                placeholder="Status"
                classNamePrefix="select2-selection"
              />
            </div>
          </>) : ""}
        <div className="col-sm-1">
          <Select
            value={formState.orderStatus}
            transition
            onChange={e => handleSelectChange(e, "orderStatus")}
            options={orderStatus}
            placeholder="orderStatus"
            classNamePrefix="select2-selection"
          />
        </div>

        <div className="col-sm-2">
          <Label className="visually-hidden" htmlFor="autoSizingInputGroup">
            Search By Order Date
          </Label>
          <InputGroup>
            <div className="input-group-text">@</div>
            <Flatpickr
              // defaultValue="0"
              className="form-control d-block"
              placeholder="dd M,yyyy"
              value={formState.orderDate || ""}
              onChange={handleDateChange}
              // onChange={(rec, date) => setOrderDate(rec)}
              options={{
                mode: "range",
                dateFormat: "Y-m-d",
              }}
            />
          </InputGroup>
        </div>

        <div className="col-sm-1">
          <button
            type="button"
            className="btn btn-primary w-md col-sm-12"
            onClick={() => 
              handleFilterClick(formState)
            }
          >
            {/*  */}
            Submit
          </button>
        </div>
        {/* </Form> */}
      </CardBody>
    </Card>
  )
}

FilterComponentForOrders.propTypes = {
  handleFilterClick: PropTypes.func,
  filter: PropTypes.object,
}

export default FilterComponentForOrders
